import { render, staticRenderFns } from "./AllCertificates.vue?vue&type=template&id=dc75f7a2"
import script from "./AllCertificates.vue?vue&type=script&lang=js"
export * from "./AllCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports